export const TEXTS = {
  ACCEPTANCE_ADVANCED_MODAL_TITLE: 'Выбор типа оплаты',
  ACCEPTANCE_ADVANCED_MODAL_DESCRIPTION_HEADER: 'Текущий тип оплаты — СберБизнес.',
  ACCEPTANCE_ADVANCED_MODAL_DESCRIPTION:
    'Для создания и оплаты новых адресов надо подписать согласие на списание со счёта СберБизнес или выбрать другой тип оплаты.',
  ACCEPTANCE_ADVANCED_MODAL_PRIMARY_BUTTON_TEXT: 'Перейти в СберБизнес',
  ACCEPTANCE_ADVANCED_MODAL_SECONDARY_BUTTON_TEXT: 'Выбрать другой тип оплаты',
  ACCEPTANCE_ADVANCED_MODAL_NOTIFICATION_ERROR_MESSAGE: 'Ошибка при подписании Согласия на списание. Повторите попытку',
};
